import { useMemo, useState } from 'react';
import { hotSeries } from '@/mocks/comicData';
import ComicCard from './ComicCard';

interface HotSeriesProps {
  keyword: string;
}

const tabs = [
  { key: 'all', label: '全部' },
  { key: 'guoman', label: '国漫' },
  { key: 'riman', label: '日漫' },
] as const;

export default function HotSeries({ keyword }: HotSeriesProps) {
  const [tab, setTab] = useState<(typeof tabs)[number]['key']>('all');

  const list = useMemo(() => {
    const kw = keyword.toLowerCase();
    return hotSeries.filter((item) => {
      const typeOk = tab === 'all' || item.type === tab;
      const kwOk =
        !kw ||
        item.title.toLowerCase().includes(kw) ||
        item.tags.some((t) => t.toLowerCase().includes(kw)) ||
        item.intro.includes(keyword);
      return typeOk && kwOk;
    });
  }, [keyword, tab]);

  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              <i className="ri-fire-line"></i>热门连载
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              正在追更的热门连载
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600 md:text-base">
              {keyword
                ? `为你找到与“${keyword}”相关的连载作品`
                : '每日更新的热门连载，按人气整理，最新章节一眼掌握。'}
            </p>
          </div>

          {/* 标签切换 */}
          <div className="inline-flex w-fit items-center rounded-full border border-background-200 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${
                  tab === t.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {list.map((item) => (
              <ComicCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="mt-8 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-search-eye-line text-4xl text-foreground-300"></i>
            <p className="mt-3 text-sm text-foreground-600">暂时没有找到与“{keyword}”匹配的连载</p>
            <button
              type="button"
              onClick={() => setTab('all')}
              className="mt-4 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-secondary-700"
            >
              查看全部连载
            </button>
          </div>
        )}
      </div>
    </section>
  );
}